import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import ErrorPage from './components/pages/ErrorPage';
import './App.scss';
import './styles/mui-tabs-style-override.scss';
import useUserAuthStatus from './firebase/hooks/use-user-auth-status';
import './interceptors/http-service.interceptor';
import { Loader } from '@googlemaps/js-api-loader';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './common/query-client';

const router = createBrowserRouter([
  { path: '*', element: <AppRoutes />, errorElement: <ErrorPage /> },
]);

const App = () => {
  const isInitialUserFetch = useUserAuthStatus();
  const reactMapsApiKey = process.env.REACT_APP_MAPS_API_KEY;

  useEffect(() => {
    if (reactMapsApiKey) {
      const loader = new Loader({
        apiKey: reactMapsApiKey,
        version: 'weekly',
        libraries: ['places'],
      });

      const loadLibrary = async () => {
        await loader.importLibrary('places');
      };

      loadLibrary();
    }
  }, [reactMapsApiKey]);

  if (isInitialUserFetch) {
    return null;
  }

  return (
    <QueryClientProvider client={queryClient}>
      {/* Navigations must commit synchronously: a page that is still mounted
          during a transition would write its default query params onto the
          URL of the page being opened. */}
      <RouterProvider router={router} useTransitions={false} />
    </QueryClientProvider>
  );
};

export default App;
